import { IHistoryData } from './../shared/shared';
import { useMemo } from 'react';
import { ICountryFlagProps } from 'types/shared';
import { IExportJob, IAvailableCustomerResult } from '../shared/shared';

const useJobs = (
  jobs: undefined | IExportJob[],
  jobHistory: IHistoryData[],
  availableCustomers: IAvailableCustomerResult[],
  countries: ICountryFlagProps[]
): null | IExportJob[] => {
  return useMemo(() => {
    if (!jobs || !availableCustomers) return null;

    return jobs.map((job: IExportJob) => ({
      ...job,
      countries: job.geoIds
        ? job.geoIds
            .map(
              (geoId: string) =>
                countries.find((c: ICountryFlagProps) => c.id === geoId)
                  ?.displayName
            )
            .join(', ')
        : 'Global',
      customerIds: job.customerIds?.map((cid) => cid.toString()),
      customerNames: job.customerIds
        ?.map(
          (customerId: string) =>
            availableCustomers.find(
              (customer: IAvailableCustomerResult) =>
                customer.id === Number(customerId)
            )?.displayName
        )
        .join(', '),
      lastRunStatus:
        (jobHistory &&
          jobHistory.find((jh) => jh.jobId === job.id)?.runStatus) ||
        job.lastRunStatus,
    }));
  }, [jobs, availableCustomers, countries, jobHistory]);
};

export default useJobs;
